"use strict";

var WaveformData = require("./lib/core");
WaveformData.adapters = require("./lib/adapters");

module.exports = WaveformData;
